import VersionCompareKeyValueGrid from 'components/v2/compiler/version-compare/VersionCompareKeyValueGrid';
import { VersionCompareRow } from 'components/v2/compiler/version-compare/VersionCompareRow';
import { EpdVersionHistoryData } from 'components/v2/compiler/version-history/utils/EpdVersionHistoryDataContext';
import React from 'react';
import { FieldPanelHeader } from 'styles/v2/Styles.styled';
import ComparePanelComponent from '../../../../pages/v2/compiler/ComparePanelComponent';
import { getScenarioGridRows } from '../version-history/content/VersionHistoryScenarioGrid';
import { getScenarioModules } from '../version-history/content/VersionHistoryScenariosSection';
import CompareScenarioModuleSection from './CompareScenarioModuleSection';
import { mergeToLeftRightByIndex, mergeToLeftRightByKey } from './utils/mergers';

const CompareScenariosSection: React.FC<{
  data: { left: EpdVersionHistoryData | null; right: EpdVersionHistoryData | null };
}> = ({ data }) => {
  const mergedScenariosInformation = mergeToLeftRightByIndex(data.left?.scenarios, data.right?.scenarios);
  return (
    <>
      {mergedScenariosInformation.map((pair, scenarioIndex) => {
        const leftModules = getScenarioModules(data.left!, pair.left);
        const rightModules = getScenarioModules(data.right!, pair.right);

        const mergedModules = mergeToLeftRightByKey(leftModules, rightModules, (x) => x.moduleId, { sort: true });

        return (
          <ComparePanelComponent key={pair.left?.id || pair.right?.id}>
            <VersionCompareRow data={pair} displayCondition={(x) => !!x}>
              {({ item }) => (
                <FieldPanelHeader>
                  {item.isDefaultScenario ? 'Default scenario' : `Additional scenario ${scenarioIndex}`}
                </FieldPanelHeader>
              )}
            </VersionCompareRow>

            <VersionCompareRow data={pair} displayCondition={(x) => !!x}>
              {({ isLeft }) => (
                <VersionCompareKeyValueGrid isLeft={isLeft} additionalData={pair} rowsGetter={getScenarioGridRows} />
              )}
            </VersionCompareRow>

            {mergedModules.map((scenarioModule, moduleIndex) => {
              const moduleId = scenarioModule?.left?.moduleId ?? scenarioModule?.right?.moduleId ?? `module_${moduleIndex}`;

              return (
                <CompareScenarioModuleSection
                  key={`${moduleId}_${scenarioIndex}_${moduleIndex}`}
                  versionData={data}
                  scenarioData={pair}
                  moduleData={scenarioModule}
                />
              );
            })}
          </ComparePanelComponent>
        );
      })}
    </>
  );
};

export default CompareScenariosSection;
